import { render } from "./ThePatientConsultationView.vue?vue&type=template&id=08cdb4dc&scoped=true&ts=true"
import script from "./ThePatientConsultationView.vue?vue&type=script&lang=ts"
export * from "./ThePatientConsultationView.vue?vue&type=script&lang=ts"

import "./ThePatientConsultationView.vue?vue&type=style&index=0&id=08cdb4dc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cdb4dc"]])

export default __exports__